// @flow
import React from 'react';
import {withRouter} from 'react-router';
import queryString from 'query-string';
import {MainLayout as Layout} from 'app/layouts/MainLayout';
import Post from 'app/components/Post';

class Single extends React.Component<Props> {
	render() {
    const searchParams = queryString.parse(this.props.location.search);
    let gotoComments = false;
    if (searchParams && searchParams.goto) {
      gotoComments = searchParams.goto;
    }
		return (
			<Layout>
				<Post goto={gotoComments} slug={this.props.match.params.slug} />
			</Layout>
		);
	}
}

const Component = withRouter(Single);
export {Component as Single}
export default Component;